/**
 * 文件流下载工具函数
 * @param {any} data - 接口返回的blob文件流
 * @param {string} type - 文件类型
 * @param {string} name - 文件名
 */
import { Message } from "element-ui";
export const downloadFile = (data, type, name, messageTip) => {
  const blob = new Blob([data], { type: type || "application/vnd.ms-excel" });
  const downloadElement = document.createElement("a");
  const href = window.URL.createObjectURL(blob);
  downloadElement.href = href;
  downloadElement.download = name;
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
  window.URL.revokeObjectURL(href);
  Message({
    message: messageTip ? messageTip : "导出成功",
    type: "success"
  });
};

export function getFileName(disposition) {
  if (!disposition) return "download.xlsx";

  const fileNameStarMatch = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (fileNameStarMatch?.[1]) {
    return decodeURIComponent(fileNameStarMatch[1]);
  }

  const fileNameMatch = disposition.match(/filename\s*=\s*"?([^";]+)"?/i);
  if (fileNameMatch?.[1]) {
    let fileName = fileNameMatch[1].trim();
    if (/%[0-9A-Fa-f]{2}/.test(fileName)) {
      return decodeURIComponent(fileName);
    }

    try {
      return decodeURIComponent(escape(fileName));
    } catch (e) {
      console.log(e);
    }
    return fileName;
  }

  return "download.xlsx";
}
